module.exports = __webpack_public_path__ + "img/loreto-paddle.4d199dd0.jpg";